import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./KPIAnalyticsOverviewPage.less');
const DataSet = require('@antv/data-set');

const KPIAnalyticsOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/analytics/kpi/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'vendors',
			name: 'Vendors',
		},
		{
			key: 'supplierPerformance',
			name: 'Supplier Performance',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/analytics/kpi/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/analytics/kpi/overview/vendors`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Scorecards"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="kpiAnalyticsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(KPIAnalyticsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
